export default {
    removeHmtl  (content) {
        return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "");
    },
    removeHtml  (content) {
        return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "");
    }
}


// WEBPACK FOOTER //
// ./src/js/document.js